'use client';

import React from 'react';
import { useThemeStore } from '@/stores/themeStore';

export function ThemeToggle(): React.JSX.Element {
  const { theme, toggleTheme } = useThemeStore();

  return (
    <button
      onClick={toggleTheme}
      type="button"
      className="flex items-center space-x-1.5 px-3 py-1.5 rounded-full border transition-all duration-300 text-xs font-mono font-bold cursor-pointer bg-[#12111F] text-amber-400 border-amber-400/40 hover:bg-amber-400/10 shadow-sm"
      title={theme === 'dark' ? 'Cambiar a Modo Día (Cielo Celestial)' : 'Cambiar a Modo Noche (Cosmos)'}
    >
      <span>{theme === 'dark' ? '☀️' : '🌙'}</span>
      <span className="hidden sm:inline">
        {theme === 'dark' ? 'Modo Día' : 'Modo Noche'}
      </span>
    </button>
  );
}
